import Button from '../../Button'
import { ICON_CHEVRON_DIRECTION } from '../../Icon'
import { NavArrowButton } from '../../NavArrow'
import Text from '../../Text'

import * as styles from './FilesGalleryActions.module.css'

function FilesGalleryActions({
  activeFileListIndex,
  showNext,
  showPrev,
  totalCount,
  onClickNext,
  onClickPrev,
}) {
  return (
    <>
      {showPrev ? (
        <div className={styles.arrowLeft} onClick={onClickPrev}>
          <NavArrowButton
            isGrey
            Component={Button.Contained}
            direction={ICON_CHEVRON_DIRECTION.LEFT}
          />
        </div>
      ) : null}
      {showNext ? (
        <div className={styles.arrowRight} onClick={onClickNext}>
          <NavArrowButton isGrey Component={Button.Contained} />
        </div>
      ) : null}
      {totalCount > 1 ? (
        <div className={styles.counter}>
          <Text
            isSecondary
            className={styles.textCounter}
          >{`${activeFileListIndex + 1}/${totalCount}`}</Text>
        </div>
      ) : null}
    </>
  )
}

export default FilesGalleryActions
